/* import libraries */
import { useNavigate, useSearchParams } from "react-router-dom";

/* import components */
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import ChevronLeft from './icons/ChevronLeft';

const Menu = (props) => {
    let navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();

    const navigateLink = () => {
        const token = searchParams.get("token");
        if (!token) {
            navigate(-1);
        } else {
            window.location.href = 'ryde://open?action=back';
        }
    }

    return (
        <>
            <Navbar 
                fixed="top" 
                sticky="top" 
                bg="#ffffff" 
                expand="lg" 
                className={props.bgColor === "#272727" ? "border-bottom-override" : "border-bottom"} 
                style={{ backgroundColor: props.bgColor ? props.bgColor : "#ffffff"}} 
            >
                <Container>
                    <ChevronLeft navigate={navigateLink} />
                    <Navbar.Brand 
                        className="mx-auto font-medium"
                        style={{ fontSize: "23px", color: "#000000"}}>
                            {props.title}
                    </Navbar.Brand>
                </Container>
            </Navbar>
        </>
    )
}

export default Menu;